import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=f79263a0&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=f79263a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79263a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f79263a0')) {
      api.createRecord('f79263a0', component.options)
    } else {
      api.reload('f79263a0', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=f79263a0&scoped=true&", function () {
      api.rerender('f79263a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileViews/ValidateTs/Main.vue"
export default component.exports